<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      {{data_id.name}}
    </v-card-title>
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="modalOpenAddFormList"
            >
              Add Spare Part Price
            </v-btn>
            <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      loading-text="Loading... Please wait"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    
     <template v-slot:[`item.spare_part_price_price`]="{ item }">
      <span style="float: left; ">Rp.</span><span style="float:right;">{{
                formatPrice(item.spare_part_price_price)
              }}</span>
     </template>
    
     <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="modalOpenEditFormType(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.id)"
      >
        mdi-delete
      </v-icon>
    </template>
    
    </v-data-table>
  </v-card>
  <modal ref="modalFormPrice" class="coba">
      <template v-slot:header>
        <h3>{{ titleFormPrice }}</h3>
        <md-button class="md-icon-button md-dense md-round"  @click="modalCloseFormPrice()">
          <md-icon >close</md-icon>
        </md-button>

      </template>

      <template v-slot:body>
        <form ref="add_spare_part_price_form" @submit.prevent="submitFormPrice">
          <md-card>
            <!-- <md-card-header class="md-card-header-icon">
              <div class="card-icon">
                <md-icon>perm_identity</md-icon>
              </div>
              <h4 class="title">
                Add Spare Part Master
              </h4>
            </md-card-header> -->
            <md-card-content>
              <input v-model="id" :readonly="true" type="hidden"/>
              <div class="md-layout">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  Dealer
                </label> -->
                <div class="md-layout-item">
                  <validation-provider rules="dealer" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Delaer</label>
                    <md-select v-model="spare_part_price_dealer_id" required>
                      <md-option v-for="option in options_dealer" :key="option.value" :value="option.id">
                        {{ option.dealer_name }}
                      </md-option>
                    </md-select>
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>
                
              <div class="md-layout">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  Minimum Order Quantity
                </label> -->
                <div class="md-layout-item">
                  <validation-provider rules="minimum" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Minimum Order Quantity</label>
                    <md-input type="text" v-on:keypress="NumbersOnly" v-model="spare_part_price_minimum_order_quantity" required/>
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              <!-- </div>
                
              <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label">
                  Price
                </label> -->
                <div class="md-layout-item">
                  <validation-provider rules="price" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Price</label>
                    <md-input type="text" v-on:keypress="NumbersOnly" v-model="spare_part_price_price" required/>
                    <span class="md-error">{{errors[0]}}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>
                
            </md-card-content>
            <md-card-actions>
              <md-button class="md-info md-dense" type="submit">
                Submit
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </template>
      
      <!-- <template v-slot:footer>
        <md-card-actions>
          <md-button class="md-dense" @click="modalCloseFormPrice">
            Close
          </md-button>
        </md-card-actions>
      </template> -->
    </modal>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import { extend } from 'vee-validate';
import { Modal } from "@/components";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";
import { required } from 'vee-validate/dist/rules';

extend('dealer', {
  ...required,
  message: 'Dealer field is required'
});
extend('minimum', {
  ...required,
  message: 'Minimum Order Quantity field is required'
});
extend('price', {
  ...required,
  message: 'Price field is required'
});

  export default {
    vuetify,
    components: {
    Modal,"downloadExcel" :JsonExcel,ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        loadTable: true,
        role: "",
        search: '',
        headers: [
          {
            text: 'Dealer Part Name',
            align: 'start',
            value: 'spare_part_price_dealer_name',
          },
          { text: 'Minimun Order Quantity', value: 'spare_part_price_minimum_order_quantity',align: 'center'},
          { text: 'Price', value: 'spare_part_price_price',align: 'right'},
          { text: 'Updated At', value: 'updated_at', align: 'center'},
          { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
        ],
        table: [],
        
        worksheetName: "Spare Part Master",
        fileName:"Spare Part Master.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
          'no' : 'no',
          'spare_part_price_part_master_code' : 'spare_part_price_part_master_code',
          'spare_part_price_part_master_name' : 'spare_part_price_part_master_name',
          'spare_part_price_dealer_name' : 'spare_part_price_dealer_name',
          'spare_part_price_minimum_order_quantity' : 'spare_part_price_minimum_order_quantity',
          'spare_part_price_price' : 'spare_part_price_price',
          created_at: "created_at",
          updated_at: "updated_at",
        },
        titleFormPrice: "Add Price",
        id: null,
        spare_part_price_dealer_id: null,
        spare_part_price_price: null,
        spare_part_price_minimum_order_quantity: null,
        options_dealer: null,
      }
    },
    async created() {
      
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
      
      await this.$store.dispatch("workshop_spare_part_price/list_price_master_id", this.data_id.id)
      if (Object.keys(await this.$store.getters["workshop_spare_part_price/list"]).length != 0) {
        this.table = await this.$store.getters["workshop_spare_part_price/list"]
      }
      else{
        this.table = []
      }
      
      this.worksheetName = "Spare Part List Price " + this.data_id.name
      this.fileName = "Spare Part List Price " + this.data_id.name +'.xls'
      this.loadTable= false
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    if(this.$refs.vTable){
      this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    }
    else{
      this.exportAllFitered = this.dataExport(this.table)
    }
    },

  // format merubah angka ke currency 
    formatPrice(value) {
        let val = (value/1).toFixed().replace('.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

    async modalOpenAddFormList() {
      this.titleFormPrice= "Add Price"
      this.resetForm()
      if(this.options_dealer == null){
        await this.$store.dispatch("workshop_part_dealer/list")
        this.options_dealer = await this.$store.getters["workshop_part_dealer/list"]
      }
        this.$refs.modalFormPrice.openModal()
    },
    async modalOpenEditFormType(item) {
      this.titleFormPrice= "Edit Price"
      if(this.options_dealer == null){
        await this.$store.dispatch("workshop_part_dealer/list")
        this.options_dealer = await this.$store.getters["workshop_part_dealer/list"]
      }
      this.id= item.id
      this.spare_part_price_dealer_id= item.spare_part_price_dealer_id
      this.spare_part_price_price= item.spare_part_price_price
      this.spare_part_price_minimum_order_quantity= item.spare_part_price_minimum_order_quantity
      this.$refs.modalFormPrice.openModal()
    },

   

    // fungsi untuk menutup pop up modal
    modalCloseFormPrice(){ 
      this.$refs.modalFormPrice.closeModal()
    },

    async submitFormPrice() {
      if(this.id==null){
        const data = {
          type: "workshop_spare_part_prices", 
          spare_part_price_master_id: this.data_id.id,
          spare_part_price_dealer_id: this.spare_part_price_dealer_id,
          spare_part_price_minimum_order_quantity: this.spare_part_price_minimum_order_quantity,
          spare_part_price_price: this.spare_part_price_price
        }
        try {
          // kirim data ke api
          await this.$store.dispatch("workshop_spare_part_price/add", data);
          // panggil alert success
          await this.$store.dispatch(
            "alerts/success",
            "Successfully registered."
          );
          this.table.push(await this.$store.getters["workshop_spare_part_price/spare_part_price"])
          this.$refs['add_spare_part_price_form'].reset();

          this.resetForm()
          this.modalCloseFormPrice()
          this.getList()
        } catch (e) {
          
          // panggil error alert
          await this.$store.dispatch(
            "alerts/error",
            "Oops, something went wrong"
          );
          this.setApiValidation(e.response.data.errors);
        }
      }
      else{
        const data = {
          type: "workshop_spare_part_prices", 
          id: this.id,
          //spare_part_price_master_id: this.data_id.id,
          spare_part_price_dealer_id: this.spare_part_price_dealer_id,
          spare_part_price_minimum_order_quantity: this.spare_part_price_minimum_order_quantity,
          spare_part_price_price: this.spare_part_price_price
        }
        try {
          await this.$store.dispatch("workshop_spare_part_price/update", data);
          await this.$store.dispatch(
            "alerts/success",
            "Successfully registered."
          );
          var indexOption = this.table.findIndex(p => p.id ==  this.id)
          //this.table[indexOption] = await this.$store.getters["workshop_spare_part_price/spare_part_price"]

          var indexOptionDealer = this.options_dealer.findIndex(p => p.id ==  this.spare_part_price_dealer_id)
          this.table[indexOption].spare_part_price_dealer_id = this.spare_part_price_dealer_id
          this.table[indexOption].spare_part_price_dealer_name = this.options_dealer[indexOptionDealer].dealer_name
          this.table[indexOption].spare_part_price_minimum_order_quantity =  this.spare_part_price_minimum_order_quantity
          this.table[indexOption].spare_part_price_price = this.spare_part_price_price
          console.log(this.options_dealer[indexOptionDealer].dealer_name)

          this.$refs['add_spare_part_price_form'].reset();
          this.resetForm()
          this.modalCloseFormPrice()
          } catch (e) {
            await this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong"
            );
            this.setApiValidation(e.response.data.errors);
          }
    }
    },
    resetForm() {
      this.id= null
      this.spare_part_price_dealer_id= null
      this.spare_part_price_price= null
      this.spare_part_price_minimum_order_quantity= null
    },


    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },
  
     // fungsi delete
    async deleteData(id) {
      try {
        await this.$store.dispatch("workshop_spare_part_price/destroy", id)
        await this.$store.dispatch(
          "alerts/success",
          "Spare Part Price data delete successfully."
        );
        var indexOptionTable = this.table.findIndex(
          (p) => p.id == id
        );
        this.table.splice(indexOptionTable, 1);
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
       return data.map((v,index) => ({...v, no: index+1}))
      
     
      }
     },
  }
</script>
<style lang="scss" scoped>

.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}

.md-layout-item{
  margin-top:10px;
}

h3{
  font-weight: bold;
  
}

.coba{
  width:600px !important;
  height:416px !important;
  margin: 50px auto !important;
  top: 1 !important;
  bottom: 1 !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>